import {ButtonHTMLAttributes, ReactElement, ReactNode} from "react";
import {omit} from "ramda";

export interface PrimaryButtonBigProps {
    children: ReactNode
}

export function PrimaryButtonBig(props: PrimaryButtonBigProps & ButtonHTMLAttributes<HTMLButtonElement>): ReactElement {
    const restAttributes = omit(["children", "className"], props);
    return (
        <button className="bg-primary rounded-full px-4 py-2.5 w-full
                           text-white font-barlow font-semibold leading-snug
                           cursor-pointer
                           disabled:bg-gray-1 disabled:cursor-default"
                {...restAttributes}>
            {props.children}
        </button>
    );
}